var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.link)?_c('a',{class:[
    'button',
    { 'button--round': _vm.round },
    { 'button--red': _vm.red },
    { 'button--white': _vm.white },
    { 'button--disabled': _vm.disabled },
    { 'button--large': _vm.large },
    { 'button--full': _vm.full },
    { 'button--icon': _vm.icon },
    { 'button--overlay': _vm.overlay },
    { 'button--border': _vm.border },
    { 'button--simple': _vm.simple }
  ],attrs:{"href":_vm.link}},[_c('span',[_vm._t("default"),(_vm.text)?_c('span',{staticClass:"button__text"},[_vm._v(" "+_vm._s(_vm.text)+" ")]):_vm._e()],2)]):(_vm.route)?_c('router-link',{class:[
    'button',
    { 'button--round': _vm.round },
    { 'button--red': _vm.red },
    { 'button--white': _vm.white },
    { 'button--disabled': _vm.disabled },
    { 'button--large': _vm.large },
    { 'button--full': _vm.full },
    { 'button--icon': _vm.icon },
    { 'button--overlay': _vm.overlay },
    { 'button--border': _vm.border },
    { 'button--simple': _vm.simple }
  ],attrs:{"to":_vm.route}},[_c('span',[_vm._t("default"),(_vm.text)?_c('span',{staticClass:"button__text"},[_vm._v(" "+_vm._s(_vm.text)+" ")]):_vm._e()],2)]):(_vm.routine)?_c('button',{class:[
    'button',
    { 'button--round': _vm.round },
    { 'button--red': _vm.red },
    { 'button--white': _vm.white },
    { 'button--disabled': _vm.disabled },
    { 'button--large': _vm.large },
    { 'button--full': _vm.full },
    { 'button--icon': _vm.icon },
    { 'button--overlay': _vm.overlay },
    { 'button--border': _vm.border },
    { 'button--simple': _vm.simple }
  ],on:{"click":_vm.routine}},[_c('span',[_vm._t("default"),(_vm.text)?_c('span',{staticClass:"button__text"},[_vm._v(" "+_vm._s(_vm.text)+" ")]):_vm._e()],2)]):_c('button',{class:[
    'button',
    { 'button--round': _vm.round },
    { 'button--red': _vm.red },
    { 'button--white': _vm.white },
    { 'button--disabled': _vm.disabled },
    { 'button--large': _vm.large },
    { 'button--full': _vm.full },
    { 'button--icon': _vm.icon },
    { 'button--overlay': _vm.overlay },
    { 'button--border': _vm.border },
    { 'button--simple': _vm.simple }
  ],attrs:{"type":"submit"}},[_c('span',[_vm._t("default"),(_vm.text)?_c('span',{staticClass:"button__text"},[_vm._v(" "+_vm._s(_vm.text)+" ")]):_vm._e()],2)])}
var staticRenderFns = []

export { render, staticRenderFns }